<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.form_label_search_shipmentBatch') ||
                  '订单编号/交货批次编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="orderBatchCisible = true"
              v-if="!disabled"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="small" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_customerOrderNo') || '客户订单号'">
              <el-input v-model.trim="form.contractNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_retailerPo') || '零售商PO'"
            >
              <el-input v-model.trim="form.retailerPo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_importerPo') || '进口商PO'"
            >
              <el-input v-model.trim="form.importerPo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_packing_dispatchPort') || '发运港口'"
            >
              <dict-select
                v-model="form.dispatchPort"
                url="/master/port/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_packing_destinationPort') || '目的港口'"
            >
              <dict-select
                v-model="form.destinationPort"
                url="/master/port/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_packingType') || '装箱方式'"
            >
              <dict-select
                v-model="form.packingType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'packingType' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentStartDate') || '客户最早交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShipmentDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShipmentDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShipmentEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShipmentEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentDate') || '客户交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shipmentEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col> -->
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDeliveryDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
    <ChooseOrderBatch
      :visible.sync="orderBatchCisible"
      :title="'订单批次'"
      :shipmentCode="shipmentCode"
      :height="450"
      @confirm="query()"
    />
  </div>
</template>

<script>
// 初始表单
import ChooseOrderBatch from '../choose-order-batch/dialog.vue'
const initForm = {
  keyword: '',
}
export default {
  components: { ChooseOrderBatch },
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      orderBatchCisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
